import { render, staticRenderFns } from "./relation-detail.vue?vue&type=template&id=bee761b8"
import script from "./relation-detail.vue?vue&type=script&lang=ts"
export * from "./relation-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports